import React, { FC } from 'react';
import styled from 'styled-components';
import { MentionData } from 'components/molecules/mention';
import { TaskDescription } from 'components/molecules/tasks/details/description';
import { ImageHandler } from 'components/organisms/task-pane/task-detail/description';
import { useTranslation } from 'hooks/use-translation';

interface Props {
  note: string | undefined;
  onUpdate: (taskDescription: string) => void;
  onMentionAdd?: (data) => void;
  mentionData?: MentionData;
  projectId?: number;
  disabled?: boolean;
}

const EditorWrapper = styled.div`
  --rte-background: var(--private-02);
  background: var(--private-02);

  &:hover {
    --rte-background: var(--private-01);

    background: var(--private-01);
  }
`;

export const PrivateNoteEditor: FC<Props> = ({
  note,
  onUpdate,
  onMentionAdd,
  projectId,
  mentionData,
  disabled,
}) => {
  const placeholder = useTranslation('task.private_note.placeholder');

  return (
    <EditorWrapper>
      <ImageHandler canOpenImage>
        <TaskDescription.Editor
          isEditorFocused={!note}
          mentionData={mentionData}
          taskDescription={note}
          updateTask={onUpdate}
          projectId={projectId}
          placeholder={placeholder}
          onMentionAdd={onMentionAdd}
          isPrivate
          disabled={disabled}
        />
      </ImageHandler>
    </EditorWrapper>
  );
};
